import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../actions/DanhSachHopDongChoDuyet";
import { formatNumber } from "utils/currencyFormat";

export const TableDanhSach = ({
  quyenDuyet,
  quyenXacNhan,
  quyenSua,
  quyenXoa,
  quyenChiTietHopDong,
  quyenChiTietKhachHang,
  showFormTraGop,
  showFormTinChap,
  inthuchi,
  phanquyen,
  showFormCamDo,
  showModalLoaiTaiSan,
  loaitaisan,
  isSuDungTatToanSom,
  isDuDungPhiPhatDongLaiTatToan,
  isSuDungCongTacVienNhanVien,
  SuDungPhiPhat_DongLai_Cham,
}) => {
  const dispatch = useDispatch();
  const listHopDongChoDuyetFull = useSelector(
    (state) => state.listHopDongChoDuyetFull
  );
  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);
  useEffect(() => {
    dispatch(getListHopDongChoDuyet(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListHopDongChoDuyet(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListHopDongChoDuyet(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = listHopDongChoDuyetFull.TongBanGhi;
  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listHopDongChoDuyetFull.getListHopDongChoDuyetLoading
                    ? "is-active"
                    : "")
                }
              ></div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listHopDongChoDuyetFull.TongBanGhi} ]
                      </span>
                    </p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-15-6-sm">
                    <p className="text-center">Mã hợp đồng</p>
                  </div>

                  <div className="custom-table-header flex-basis-15 flex-basis-12-8-sm">
                    <p>Tên khách hàng</p>
                  </div>

                  <div className="custom-table-header flex-basis-14 flex-basis-11-2-sm">
                    <p className="text-center">Tên tài sản</p>
                  </div>

                  <div className="custom-table-header flex-basis-13 flex-basis-12-sm">
                    <p className="text-center">Thời gian</p>
                  </div>

                  <div className="custom-table-header flex-basis-17 flex-basis-15-8-sm">
                    <p className="text-right">
                      Số tiền vay
                      <br />{" "}
                      <span className="color-do-bold">
                        {formatNumber(listHopDongChoDuyetFull.TongSoTien)}
                      </span>
                    </p>
                  </div>

                  <div className="custom-table-header flex-basis-12 flex-basis-15-sm">
                    <p className="text-center">Trạng thái</p>
                  </div>

                  <div className="custom-table-header flex-basis-11 flex-basis-11-6-sm">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listHopDongChoDuyetFull={listHopDongChoDuyetFull.List}
                    quyenDuyet={quyenDuyet}
                    quyenXacNhan={quyenXacNhan}
                    quyenSua={quyenSua}
                    quyenXoa={quyenXoa}
                    quyenChiTietHopDong={quyenChiTietHopDong}
                    quyenChiTietKhachHang={quyenChiTietKhachHang}
                    showFormTraGop={showFormTraGop}
                    showFormTinChap={showFormTinChap}
                    inthuchi={inthuchi}
                    phanquyen={phanquyen}
                    showFormCamDo={showFormCamDo}
                    showModalLoaiTaiSan={showModalLoaiTaiSan}
                    loaitaisan={loaitaisan}
                    isDuDungPhiPhatDongLaiTatToan={
                      isDuDungPhiPhatDongLaiTatToan
                    }
                    SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
                    isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
                    isSuDungTatToanSom={isSuDungTatToanSom}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
